/**
 * Генерирует HSL-цвет, избегая красных тонов (диапазон оттенков 30-330).
 * Используется для назначения различных цветов элементам.
 * @param {number} index - Индекс элемента.
 * @param {number} total - Общее количество элементов.
 * @returns {string} Строка CSS-цвета в формате hsl().
 */
export function generateColorWithoutRed(index, total) {
  const startHue = 30; // избегаем красного
  const endHue = 330;
  const hueRange = endHue - startHue;

  const hue = startHue + (index * hueRange) / total;

  return `hsl(${hue}, 70%, 40%)`;
}

export default generateColorWithoutRed;
